module.exports = __webpack_public_path__ + "media/images/pin-3b2ea1c552d9cc74e228a0278af02410.svg";